import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import WarrantyApi from '../../Api/WarrantyApi';
import { Warranty } from '../../Models/Warranty';
import WarrantyListTable from './WarrantyListTable';

export default function WarrantyList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [warrantyListData, setWarrantyListData] = useState<Warranty[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getWarranties = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return WarrantyApi.getWarranties(0)
          .then((res) => {
            const sorted = [...res.data].sort((a, b) => {
              const dateA = new Date(a.date ?? '').getTime();
              const dateB = new Date(b.date ?? '').getTime();
              return dateB - dateA; // descending
            });
            setWarrantyListData(sorted);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getWarranties();
  }, [getWarranties]);

  function deleteWarranty(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Warranty Claims</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
            <WarrantyListTable
              data={warrantyListData}
              deleteWarranty={deleteWarranty}
            />
          </div>
        </div>
      </div>
    </>
  );
}
